import { useEffect, useState } from "react";
import { useLayoutMode } from "./useLayoutMode";
import { getUnzoomedWidth } from "@/lib/viewportUtils";

/**
 * Returns true when the viewport is too narrow for a two-column layout.
 * Uses 1024px (Tailwind `lg`) instead of the global isMobile breakpoint (768px)
 * so that iPad portrait stacks vertically while iPad landscape / desktop
 * shows two columns.
 */
export function useIsStacked(): boolean {
  const { layoutMode } = useLayoutMode();
  const [isNarrow, setIsNarrow] = useState(true);

  useEffect(() => {
    const handleResize = () => setIsNarrow(getUnzoomedWidth() < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    window.visualViewport?.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  return isNarrow || layoutMode === "native";
}
